import Service1 from "./1.svg";
import Service2 from "./2.svg";
import Service3 from "./3.svg";
import Service4 from "./4.svg";
import Service5 from "./5.svg";
import Service6 from "./6.svg";

export const serviceAssets = {
  Service1,
  Service2,
  Service3,
  Service4,
  Service5,
  Service6,
};
